import { render, staticRenderFns } from "./SubscriptionOrdersShipping.vue?vue&type=template&id=bc3fa78c&scoped=true&lang=pug&"
import script from "./SubscriptionOrdersShipping.vue?vue&type=script&lang=js&"
export * from "./SubscriptionOrdersShipping.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionOrdersShipping.vue?vue&type=style&index=0&id=bc3fa78c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3fa78c",
  null
  
)

export default component.exports